'use strict';

const { queryFirst, addClass, removeClass, queryAll, setAttribute, removeAttribute, hasClass } = require('../domUtil');
const { getJSON, appendToUrl, getNestedValue, setItemInLocalStorage } = require('../util');
const { shippingPreferences } = require('../templates').shippingPreferenceTemplates;
const { ispuSelectStyleMessageTmpl } = require('../templates').productDetail;
const { isShippingPreferencesViewEnabled } = require('../product/helper');
const {
    getChangeStoreLinkEl, getSelectedPreferenceEl, getShippingPreferencesContainerEl, getISPUradioButtonEl, getSelectedSizeEl,
    getShipToAddressradioButtonEl, getISPUPreferenceContentEl, addStoreNameClass, removeStoreNameClass,
    selectISPURadioButton, selectShipToRadioButton, getPreferedShippingPreference, disableISPURadioButton, disableShipToRadioButton, getShipToAddressContentEl, updateVisibilityOfLowInventoryMsg, getAvailableForInStorePickup
} = require('./shippingPreference/shippingPreferenceHelper');
const { updateShipToInventoryMessages, updateISPUInventoryMessages, clearAllInventoryMessages, updateServiceResponseMessage, clearServiceResponseMessage } = require('./shippingPreference/inventoryMessaging');
const { injectISPUDeliveryMessage, clearISPUDeliveryMessage, showISPUDeliveryMessage, hideISPUDeliveryMessage } = require('./shippingPreference/ispuDeliveryMessaging');
const { getStoreDetailEl, addStoreDetail } = require('./shippingPreference/storeDetailHelper');
const { isEDDApplicable, injectEDDInfo, removeEDDInfo } = require('./pdpEdd');
const { EMPTY_STRING, HIDDEN_CLASS, NOT_AVAILABLE_STATUS } = require('../constants');
const {
    DISABLED_CLASS, PRODUCT_DETAIL_CONTAINER_SELECTOR, SHIPPING_PREFERENCES_CONTAINER_SELECTOR, ISPU_SELECT_STYLE_MESSAGE_SELECTOR, ISPU_SERVICE_ERROR_ATTR_NAME,
    ISPU_RADIO_VALUE, SHIP_TO_RADIO_VALUE, SHIPPING_PREFERENCE_RADIO_BUTTON_SELECTOR, CHANGE_STORE_LINK_SELECTOR, SHIPPING_PREFERENCE_KEY, RADIO_BUTTON_LABEL_SELECTOR, STORE_DETAIL_SELECTOR, ISPU_INFO_MESSAGE_SELECTOR,
    PDP_CONTAINER_SELECTOR, AVAILABILITY_MSG_SELECTOR, NOT_AVAILABLE_CLASS, ISPU_SERVICE_BLOCKED, PRE_ORDER_CLASS, SHIP_TO_LOW_INVENTORY_CLASS, PDP_SET_PAGE
} = require('./shippingPreference/constants');

const $body = $('body');
const $shippingPreferenceContainer = $(SHIPPING_PREFERENCES_CONTAINER_SELECTOR);    // jQuery version, Used only for spinner

const shippingPreferencesConfig = getNestedValue(window, 'johnnyWasUtils.shippingPreferencesConfig') || {};
const { isEnabled, messages, reasonCodes } = shippingPreferencesConfig;
const inventoryCache = {};

/**
 * Function to clear out any existing error/info messages
 * @param {HTMLElement} productContainer - Product container
 */
function clearAllMessages(productContainer) {
    clearServiceResponseMessage(productContainer);
    clearAllInventoryMessages(productContainer);
    clearISPUDeliveryMessage(productContainer);
}

/**
 * Function to reset radio button view and state
 * @param {HTMLElement} productContainer - Product container
 */
function resetPreferences(productContainer) {
    const shipToRadioButtonEl = getShipToAddressradioButtonEl(productContainer);
    shipToRadioButtonEl.disabled = false;
    removeClass(shipToRadioButtonEl.nextElementSibling, DISABLED_CLASS);
    const shipToAddressContentEl = getShipToAddressContentEl(productContainer);
    removeClass(shipToAddressContentEl, DISABLED_CLASS);

    const ispuRadioButtonEl = getISPUradioButtonEl(productContainer);
    ispuRadioButtonEl.disabled = false;
    removeClass(ispuRadioButtonEl.nextElementSibling, DISABLED_CLASS);
    const ispuPreferenceContentEl = getISPUPreferenceContentEl(productContainer);
    removeClass(ispuPreferenceContentEl, DISABLED_CLASS);
}

/**
 * Function to inject dynamically generated HTML into DOM
 * @param {HTMLElement} productContainerEl - Product container element
 * @param {boolean} preferISPU - A flag to select the ISPU radio on load
 * @param {Object} messages - map of messages
 */
function injectShippingPreferences(productContainerEl, preferISPU, messages) {
    const shippingPreferencesContainerEl = getShippingPreferencesContainerEl(productContainerEl);
    if (shippingPreferencesContainerEl) {
        const { preferenceIspuLabel, preferenceShipToAddressLabel, changeStoreLabel } = messages || {};
        const shippingPreferencesHTML = shippingPreferences(preferenceIspuLabel, ISPU_RADIO_VALUE, preferenceShipToAddressLabel, SHIP_TO_RADIO_VALUE, changeStoreLabel, preferISPU);
        $(shippingPreferencesContainerEl).html(shippingPreferencesHTML);
    }
}

/**
 * Function to handle successful inventory api response
 * @param {Object} response - Service response
 * @param {HTMLElement} productContainer - Product container element
 */
function handleISPUInventoryResponse(response, productContainer) {
    const { success } = response;
    let isPDPSetPage = false;
    const { masterid } = productContainer.dataset;
    if (hasClass(productContainer, PDP_SET_PAGE)) {
        isPDPSetPage = true;
    }

    clearAllMessages(productContainer);
    resetPreferences(productContainer);
    let storeDetailEl = getStoreDetailEl(productContainer);
    if (storeDetailEl) {
        storeDetailEl.textContent = EMPTY_STRING;
    }

    const ispuRadioButtonEl = getISPUradioButtonEl(productContainer);
    const shipToRadioButtonEl = getShipToAddressradioButtonEl(productContainer);
    const changeStoreLinkEl = getChangeStoreLinkEl(productContainer);
    const selectedSizeEl = getSelectedSizeEl(productContainer);
    removeClass(changeStoreLinkEl, ISPU_SERVICE_BLOCKED);
    window.ispuProductInventory = window.ispuProductInventory || {};
    if (success) {
        removeAttribute(ispuRadioButtonEl, ISPU_SERVICE_ERROR_ATTR_NAME);
        if (isPDPSetPage) {
            window.ispuProductInventory[masterid] = response;

        } else {
            window.ispuProductInventory = response;
        }
        const { store, instorePickupStoreMsg } = response;

        // Add store details to DOM
        addStoreDetail(store, productContainer);
        injectISPUDeliveryMessage(instorePickupStoreMsg, productContainer);
        hideISPUDeliveryMessage(productContainer);

        if (ispuRadioButtonEl.checked) {
            // On Add to cart button click
            // it takes store-id from DIV element having 'store-name' class, making it ISPU add to cart.
            addStoreNameClass(productContainer);
        }

        // Reset change store link
        removeClass(changeStoreLinkEl, HIDDEN_CLASS);

        // Show store details, if the size is selected
        if (selectedSizeEl) {
            $(selectedSizeEl).trigger('click');
            removeClass(storeDetailEl, HIDDEN_CLASS);
            if (getAvailableForInStorePickup(productContainer)) {
                removeClass(changeStoreLinkEl, DISABLED_CLASS);
            }
        } else {
            storeDetailEl = queryFirst(STORE_DETAIL_SELECTOR, productContainer);
            addClass(storeDetailEl, HIDDEN_CLASS);
            addClass(changeStoreLinkEl, DISABLED_CLASS);
            disableISPURadioButton(productContainer, null, true);

            // Displaying 'Select size message'
            const ispuAvailabilityMessageEl = queryFirst(ISPU_SELECT_STYLE_MESSAGE_SELECTOR, productContainer);
            const { selectStylesMessage } = messages;
            if (ispuAvailabilityMessageEl && selectStylesMessage) {
                ispuAvailabilityMessageEl.innerHTML = !selectedSizeEl ? ispuSelectStyleMessageTmpl(selectStylesMessage) : EMPTY_STRING;
            }
        }

        // Update the stock of sizes according to ISPU store, only if store is selected
        if (store && store.ID) {
            updateOutOfStockSizeForIspu(productContainer, isPDPSetPage);
        }
    } else {
        setAttribute(ispuRadioButtonEl, ISPU_SERVICE_ERROR_ATTR_NAME, true);
        let productISPUInventoryJSON = window.ispuProductInventory || {};
        if (isPDPSetPage) {
            productISPUInventoryJSON[masterid] = { varients: {} };
        } else {
            productISPUInventoryJSON = { varients: {} };
        }
        window.ispuProductInventory = productISPUInventoryJSON;
        let wrapErrorMessage = false;
        disableISPURadioButton(productContainer, ispuRadioButtonEl, true);

        // Switch to 'Ship to address' radio button
        selectShipToRadioButton(productContainer, shipToRadioButtonEl, true);

        const { message, reasonCode } = response;
        let ispuPreferenceContentEl;
        let store;
        switch (reasonCode) {
            case reasonCodes.NO_STORES_FOUND:
                // Show change store link to select a new store, if nearest store is not found.
                removeClass(changeStoreLinkEl, HIDDEN_CLASS);
                break;
            case reasonCodes.STORES_SERVICE_DOWN:
                wrapErrorMessage = true;
                // Hide change store link
                addClass(changeStoreLinkEl, HIDDEN_CLASS);

                // Disable the ISPU section
                ispuPreferenceContentEl = getISPUPreferenceContentEl(productContainer);
                addClass(ispuPreferenceContentEl, DISABLED_CLASS);
                break;
            case reasonCodes.STORE_UNAVAILABLE:
                store = response.store;
                if (store) {
                    addStoreDetail(store, productContainer);
                }

                // Disable the ISPU section
                ispuPreferenceContentEl = getISPUPreferenceContentEl(productContainer);
                addClass(ispuPreferenceContentEl, DISABLED_CLASS);
                break;
            default: break;
        }

        // Show the info message why it got disabled
        if (message) {
            updateServiceResponseMessage(message, wrapErrorMessage, productContainer);
        }

        if (!selectedSizeEl) {
            addClass(changeStoreLinkEl, DISABLED_CLASS);
        }
    }
}

/**
 * Function to handle failure inventory api response
 * @param {Object} error - Service response
 * @param {HTMLElement} productContainer - Product container element
 */
function handleISPUInventoryError(error, productContainer) {
    window.ispuProductInventory = { variants: {} };
    clearAllMessages(productContainer);
    resetPreferences(productContainer);

    // Disable ISPU radio button and display error message
    disableISPURadioButton(productContainer, null, true);
    const { errorMessage } = messages;
    updateServiceResponseMessage(errorMessage, true, productContainer);
    const changeStoreLinkEl = getChangeStoreLinkEl(productContainer);
    addClass(changeStoreLinkEl, ISPU_SERVICE_BLOCKED);

    // Fallback to ship to address radio button
    selectShipToRadioButton(productContainer);
}

/**
 * Function to updateOutOfStockSize to instock if pickup instore is available for the size
 */
function updateOutOfStockSizeForIspu(productContainer, isPDPSetPage) {
    const { ispuProductInventory, productInfo } = window;
    const pdpContainer = isPDPSetPage ? productContainer : queryFirst(PDP_CONTAINER_SELECTOR);
    const productId = pdpContainer.dataset.masterid;
    const selectedColorElement = queryFirst('.color-attribute .swatch-circle.selected', productContainer);
    const selectedColorValue = selectedColorElement.dataset.attrValue;
    const variationGroup = getNestedValue(productInfo, '{0}.variants.{1}', productId, selectedColorValue);
    if (variationGroup) {
        queryAll('.size-container li', pdpContainer).forEach(el => {
            const sizeBtn = queryFirst('button', el);
            if (hasClass(sizeBtn, NOT_AVAILABLE_CLASS)) {
                const attributeValue = sizeBtn.dataset.attrValue;
                const getVariationJson = variationGroup.sizes[attributeValue];
                const storeAvailability = isPDPSetPage ? getNestedValue(ispuProductInventory, '{0}.variants.{1}.availabilityStatus', productId, getVariationJson ? getVariationJson.ID : '') : getNestedValue(ispuProductInventory, 'variants.{0}.availabilityStatus', getVariationJson ? getVariationJson.ID : '');
                if (storeAvailability !== undefined) {
                    const checkStoreAvailability = (getVariationJson && storeAvailability);
                    if (checkStoreAvailability !== NOT_AVAILABLE_STATUS) {
                        removeClass(sizeBtn, NOT_AVAILABLE_CLASS);
                    }
                }
            }
        });
    }
}
/**
 * Function to initialize events on shipping preferences section
 * @param {string?} storeId - storeId in from user session
 */
function initializeEvents() {
    /*
        Gets triggered twice
        #1 On color swatch selection
        #2 On selecting a store from the drawer
    */
    $body.on('product:updateStoreInventory', (event, data) => {
        const { productContainer, storeId } = data;
        const shippingPreferencesContainerEl = getShippingPreferencesContainerEl(productContainer);

        // Fetching selected swatch product id from dataset
        const selectedSwatchButton = queryFirst('.swatch-circle.selected', productContainer).closest('.color-attribute');
        if (selectedSwatchButton) {
            const { productId } = selectedSwatchButton.dataset;
            const actionUrl = getNestedValue(window, 'johnnyWasUtils.shippingPreferencesConfig.actionUrl') || EMPTY_STRING;
            if (!actionUrl) return;

            // Build params for API call
            const params = { pid: productId };
            let skipCall = false;
            if (storeId) {
                window.johnnyWasUtils.shippingPreferencesConfig.storeId = params.storeID = storeId;
            } else {
                const sessionStoreId = getNestedValue(window, 'johnnyWasUtils.shippingPreferencesConfig.storeId') || EMPTY_STRING;
                if (sessionStoreId === 'null') {
                    skipCall = true;
                } else if (sessionStoreId) {
                    params.storeID = sessionStoreId;
                }
            }
            if (skipCall) {
                handleISPUInventoryResponse({
                    success: false,
                    reasonCode: reasonCodes.NO_STORES_FOUND,
                    message: messages.selectStylesMessage
                }, productContainer);
                return;
            }
            const paramHash = productId + (params.storeID || '');
            if (inventoryCache[paramHash]) {
                handleISPUInventoryResponse(inventoryCache[paramHash], productContainer);
                return;
            }
            const urlWithParams = appendToUrl(actionUrl, params);

            // Spinner for shipping preferences element
            const $spinner = $(shippingPreferencesContainerEl).spinner();
            $spinner.start();

            // Service call
            getJSON(urlWithParams, 'GET', null,
                (response) => {
                    inventoryCache[paramHash] = response;
                    handleISPUInventoryResponse(response, productContainer);
                    $spinner.stop();
                },
                (error) => {
                    handleISPUInventoryError(error, productContainer);
                    $spinner.stop();
                });
        }
    });

    $body.on('product:pdpSizeSelected', ($event, data) => {
        const { productContainer } = data;

        const storeDetailEl = getStoreDetailEl(productContainer);
        const changeStoreLinkEl = getChangeStoreLinkEl(productContainer);

        // If ISPU enabled, hiding the availability message for ship to address and
        // handling it from updateVisibilityOfLowInventoryMsg method
        const availabilityElement = queryFirst(AVAILABILITY_MSG_SELECTOR, productContainer);
        addClass(availabilityElement, HIDDEN_CLASS);

        if (storeDetailEl) {
            removeClass(storeDetailEl, HIDDEN_CLASS);
            removeClass(changeStoreLinkEl, DISABLED_CLASS);
        } else {
            const storeServiceResponse = queryFirst(ISPU_INFO_MESSAGE_SELECTOR, productContainer);
            addClass(storeServiceResponse, HIDDEN_CLASS);
            let ispuInfomessage = getAvailableForInStorePickup(productContainer) ? messages.noStoresFound : messages.notEligibleISPUMessage;
            updateServiceResponseMessage(ispuInfomessage, false, productContainer);
        }
        updateVisibilityOfLowInventoryMsg(productContainer);
    });
    $body.on('product:updateOOSSize', ($event, data) => {
        const { productContainer, isPDPSetPage } = data;
        updateOutOfStockSizeForIspu(productContainer, isPDPSetPage);
    });

    $body.on('product:inventoryStatus', function ($event, data) {
        const { shipToAddressAvailabilityStatus, inStorePickUpAvailabilityStatus, isStorePickUpLowInventory, inStorePickUpAvailabilityMessage, inStorePickUpLowStockMessage, availableForInStorePickup, productContainer } = data;

        const changeStoreLinkEl = getChangeStoreLinkEl(productContainer);
        const ispuRadioButtonEl = getISPUradioButtonEl(productContainer);
        const shipToRadioButtonEl = getShipToAddressradioButtonEl(productContainer);

        if (!ispuRadioButtonEl || !shipToRadioButtonEl) {
            return;
        }

        // Reset the radio button's state
        removeAttribute(ispuRadioButtonEl, 'disabled');
        removeAttribute(shipToRadioButtonEl, 'disabled');

        // Reset the change store link state
        removeClass(changeStoreLinkEl, HIDDEN_CLASS);

        if (availableForInStorePickup) {
            removeClass(changeStoreLinkEl, DISABLED_CLASS);
        } else {
            addClass(changeStoreLinkEl, DISABLED_CLASS);
        }

        // Updating inventory messages
        updateShipToInventoryMessages(shipToAddressAvailabilityStatus, messages, productContainer);
        const ispuAvailabilityMessageEl = queryFirst(ISPU_SELECT_STYLE_MESSAGE_SELECTOR, productContainer);
        ispuAvailabilityMessageEl.innerHTML = EMPTY_STRING;
        if (!ispuRadioButtonEl.hasAttribute(ISPU_SERVICE_ERROR_ATTR_NAME)) {
            updateISPUInventoryMessages(inStorePickUpAvailabilityStatus, isStorePickUpLowInventory, inStorePickUpAvailabilityMessage, inStorePickUpLowStockMessage, messages, productContainer, availableForInStorePickup);
        }

        const preferenceValue = getPreferedShippingPreference();
        if (availableForInStorePickup && inStorePickUpAvailabilityStatus !== NOT_AVAILABLE_STATUS) {  // ISPU is available
            showISPUDeliveryMessage(productContainer);

            // Enable ISPU content
            const ispuContentEl = getISPUPreferenceContentEl(productContainer);
            const ispuLabelEl = queryFirst(RADIO_BUTTON_LABEL_SELECTOR, ispuRadioButtonEl.parentElement);
            removeClass([ispuContentEl, ispuLabelEl], DISABLED_CLASS);
            ispuRadioButtonEl.disabled = false;

            const selectedPreferenceEl = getSelectedPreferenceEl(productContainer);

            // If previously user preference is ISPU and (if there is no radio button selected or selected radio is not ISPU)
            if (preferenceValue === ISPU_RADIO_VALUE &&
                (!selectedPreferenceEl || (selectedPreferenceEl !== ispuRadioButtonEl))) {
                selectISPURadioButton(productContainer, ispuRadioButtonEl);
            }
        } else {                                                                                            // ISPU is not available
            disableISPURadioButton(productContainer, ispuRadioButtonEl, true);
            hideISPUDeliveryMessage(productContainer);
        }

        if (shipToAddressAvailabilityStatus !== NOT_AVAILABLE_STATUS) {  // Ship to address is available
            // Enable ship To content
            const shipToContentEl = getShipToAddressContentEl(productContainer);
            const shipToLabelEl = queryFirst(RADIO_BUTTON_LABEL_SELECTOR, shipToRadioButtonEl.parentElement);
            removeClass([shipToContentEl, shipToLabelEl], DISABLED_CLASS);
            shipToRadioButtonEl.disabled = false;

            const selectedPreferenceEl = getSelectedPreferenceEl(productContainer);

            // Fallback to shipTo if no radio button is selected (If ISPU is unavailable)
            if (!selectedPreferenceEl) {
                selectShipToRadioButton(productContainer, shipToRadioButtonEl);
            }
        } else {                                                                                            // Ship to address is not available
            disableShipToRadioButton(productContainer, shipToRadioButtonEl, true);

            // If ISPU is available
            if (availableForInStorePickup && inStorePickUpAvailabilityStatus !== NOT_AVAILABLE_STATUS) {
                selectISPURadioButton(productContainer, ispuRadioButtonEl);
            }
        }
        // Displaying Ship To EDD information
        if (isEDDApplicable(shipToAddressAvailabilityStatus)) {
            injectEDDInfo(productContainer);
        } else {
            removeEDDInfo(productContainer);
        }
    });

    // On shipping preference radio button 'change'
    $shippingPreferenceContainer.on('change', SHIPPING_PREFERENCE_RADIO_BUTTON_SELECTOR, (event) => {
        const radioButtonEl = event.target;
        const productContainer = radioButtonEl.closest(PRODUCT_DETAIL_CONTAINER_SELECTOR);

        // On Add to cart button click
        // it takes store-id from DIV element having 'store-name' class, making it ISPU add to cart.
        const availabilityElement = queryFirst(AVAILABILITY_MSG_SELECTOR, productContainer);
        if (radioButtonEl.checked &&
            radioButtonEl.value === ISPU_RADIO_VALUE) {
            setItemInLocalStorage(SHIPPING_PREFERENCE_KEY, ISPU_RADIO_VALUE);
            addStoreNameClass(productContainer);
            addClass(availabilityElement, HIDDEN_CLASS);
        } else {
            setItemInLocalStorage(SHIPPING_PREFERENCE_KEY, SHIP_TO_RADIO_VALUE);
            removeStoreNameClass(productContainer);
            removeClass(availabilityElement, HIDDEN_CLASS);
        }
        updateVisibilityOfLowInventoryMsg(productContainer);
    });

    // On change-store link 'click'
    $shippingPreferenceContainer.on('click', CHANGE_STORE_LINK_SELECTOR, (event) => {
        const productContainerEl = event.target.closest(PRODUCT_DETAIL_CONTAINER_SELECTOR);
        if (!getSelectedSizeEl(productContainerEl)) return;
        const inStorePickupCTA = queryFirst('.btn-in-store-pickup', productContainerEl);
        $(inStorePickupCTA).trigger('click');
    });
}

// Injecting radio button and content dynamically
if (isShippingPreferencesViewEnabled()) {
    if (isEnabled && $shippingPreferenceContainer.length) {
        // Injects shipping preferences radio buttons
        const preferISPU = getPreferedShippingPreference() === ISPU_RADIO_VALUE;
        queryAll(PRODUCT_DETAIL_CONTAINER_SELECTOR).forEach(el => {
            injectShippingPreferences(el, preferISPU, messages);
        });

        // Updates data attribute on ISPU container to display select store view
        setAttribute(queryAll('.pickup-in-store-container'), 'data-select-store-view', true);

        // Hides Store Pick Up button exists below add to cart button
        addClass(queryAll('.pdp-in-store-inventory'), HIDDEN_CLASS);

        // Attaches events on radio button changes, color swatch changes, size changes, change store link
        initializeEvents();
    }
}
